// @file Vuex store module for all things related to browser
import { windowHeight, windowWidth, isDarkModeEnabled } from 'bits/browser'
import { isFullscreen } from 'bits/fullscreen'

interface BrowserState {
  isFullscreen: boolean
  windowWidth: number
  windowHeight: number
  darkMode: boolean
}

// Should be able to initialize with this in a context that doesn't have a full browser,
// e.g. for tests.
const blankState = (): BrowserState => ({
  isFullscreen: false,
  windowWidth: 1366,
  windowHeight: 768,
  darkMode: false,
})

const initialState = (): BrowserState => ({
  isFullscreen: isFullscreen(),
  windowWidth,
  windowHeight,
  darkMode: isDarkModeEnabled(),
})

const browserModule = {
  namespaced: true,
  state: blankState,
  getters: {
    isFullscreen: (state): boolean => state.isFullscreen,
    windowWidth: (state): number => state.windowWidth,
    windowHeight: (state): number => state.windowHeight,
    isMobileView: (state): boolean => state.windowWidth <= 700,
    isSmallerThanTabletLandscape: (state): boolean => state.windowWidth <= 1024,
    isPhone: (state): boolean => state.windowWidth < 767,
    isSmallPhone: (state): boolean => state.windowWidth <= 375,
    showMenuIcon: (state): boolean => state.windowWidth <= 800,
  },
  mutations: {
    INITIALIZE_STATE(state, data): void {
      Object.assign(state, data)
    },
    RESIZE_WINDOW(state, { width, height }): void {
      state.windowWidth = width
      state.windowHeight = height
    },
    ENTER_FULLSCREEN(state): void {
      state.isFullscreen = true
    },
    EXIT_FULLSCREEN(state): void {
      state.isFullscreen = false
    },
    TOGGLE_DARK_MODE(state, data): void {
      state.darkMode = data
    },
  },
  actions: {
    initializeState({ commit }): void {
      commit('INITIALIZE_STATE', initialState())
    },
    resizeWindow({ commit }, data): void {
      const width = data.width
      const height = data.height
      commit('RESIZE_WINDOW', { width, height })
    },
    enterFullscreen({ commit }): void {
      commit('ENTER_FULLSCREEN')
    },
    exitFullscreen({ commit }): void {
      commit('EXIT_FULLSCREEN')
    },
    toggleDarkMode({ commit }, data): void {
      commit('TOGGLE_DARK_MODE', data)
    },
  },
}

export default browserModule
export { BrowserState, initialState }
